import { render, staticRenderFns } from "./FiveStarMomentButton.vue?vue&type=template&id=7515d9b8&scoped=true"
import script from "./FiveStarMomentButton.vue?vue&type=script&lang=ts"
export * from "./FiveStarMomentButton.vue?vue&type=script&lang=ts"
import style0 from "./FiveStarMomentButton.vue?vue&type=style&index=0&id=7515d9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515d9b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
